import assert from 'assert';
import {useMemo} from 'react';

import {RowModelContext} from 'notebook/tables/store/contexts/RowModelContext';
import {TableModelContext} from 'notebook/tables/store/contexts/TableModelContext';
import {CellModel, createCellModelSelector} from 'notebook/tables/store/models/CellModel';

export function useCellModel(columnIndex: number): CellModel;
export function useCellModel<T>(columnIndex: number, subSelector: (cellState: CellModel) => T): T;
export function useCellModel<T>(columnIndex: number, subSelector?: (cellState: CellModel) => T): T {
  const {rowIndex, rowModelSelector, useTableEditableStore} = RowModelContext.useContext();
  const {tableModelSelector} = TableModelContext.useContext();

  const cellModelSelector = useMemo(
    () => createCellModelSelector(rowModelSelector, columnIndex, rowIndex, tableModelSelector),
    [rowModelSelector, columnIndex, rowIndex, tableModelSelector]
  );

  return useTableEditableStore((model) => {
    const cellModel = cellModelSelector(model);
    assert(cellModel, `CellModel not found for row ${rowIndex} and column ${columnIndex}`);
    if (!subSelector) {
      return cellModel as T;
    }
    return subSelector(cellModel);
  });
}
